import getAPIPath from '../modules/api-location';

window.addCoachToTeamService = function(teamId, emailAddress, invite, firstName, lastName, allocateLicence, successFn) {
  const item = {};
  item.team_id = teamId;
  item.email_address = emailAddress;
  item.invite = invite;
  item.allocateLicence = allocateLicence;
  item.first_name = firstName;
  item.last_name = lastName;

	return $.ajax({
		url: `${getAPIPath}commandapi/add-coach-to-team`,
		type: 'put',
		data: JSON.stringify(item),
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

	});
};

window.teamRemoveCoachService = function(memberID, teamID, successFn){
	return $.ajax({
		url: `${getAPIPath}queryapi/remove-coach-from-team?team_id=${teamID}&admin_id=${memberID}`,
		type: 'delete',
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },
	});
};

window.addPlayerToTeamService = function(teamId, emailAddress, invite, firstName, lastName, allocateLicence, successFn) {
  const item = {};
  item.team_id = teamId;
  item.email_address = emailAddress;
  item.invite = invite;
  item.allocateLicence = allocateLicence;
  item.first_name = firstName;
  item.last_name = lastName;

	return $.ajax({
		url: `${getAPIPath}commandapi/add-player-to-team`,
		type: 'put',
		data: JSON.stringify(item),
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

	});
};

window.teamRemovePlayerService = function(memberID, teamID, successFn){
	return $.ajax({
		url: `${getAPIPath}queryapi/remove-player-from-team?team_id=${teamID}&user_id=${memberID}`,
		type: 'delete',
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

	});
};

window.addHeadCoachToTeamService = function(teamId, emailAddress, invite, firstName, lastName, allocateLicence, successFn) {
  const item = {};
  item.team_id = teamId;
  item.email_address = emailAddress;
  item.invite = invite;
  item.allocateLicence = allocateLicence;
  item.first_name = firstName;
  item.last_name = lastName;


	return $.ajax({
		url: `${getAPIPath}commandapi/add-head-coach-to-team`,
		type: 'put',
		data: JSON.stringify(item),
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

	});
};

window.teamRemoveHeadCoachService = function(memberID, teamID, successFn){
	return $.ajax({
		url: `${getAPIPath}queryapi/remove-head-coach-from-team?team_id=${teamID}&user_id=${memberID}`,
		type: 'delete',
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },
	});
};

window.updateTeamInfoService = function(teamId, teamName, teamBio, teamAddressLine1, teamAddressLine2, teamAddressPostcode, teamAddressCity, teamAddressType, teamLeague, teamAgeGroup, successFn) {
  const item = {};
  item.teamId = teamId;
  item.teamName = teamName;
  item.teamBio = teamBio;
  item.teamAddressLine1 = teamAddressLine1;
  item.teamAddressLine2 = teamAddressLine2;
  item.teamAddressPostcode = teamAddressPostcode;
  item.teamAddressCity = teamAddressCity;
  item.teamLeague = teamLeague;
  item.teamAgeGroup = teamAgeGroup;
  item.teamAddressType = teamAddressType;

	return $.ajax({
		url: `${getAPIPath}commandapi/team/info`,
		type: 'put',
		data: JSON.stringify(item),
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

	});
};

window.createTeamService = function (data, successFn) {

	return $.ajax({
		url: `${getAPIPath}commandapi/team/create`,
		type: 'post',
		data: data,
		success: successFn,
		async: true,
		dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

	});
};

window.deleteTeamService = function(teamID, successFn) {
	return $.ajax({
    url: `${getAPIPath}queryapi/remove-team-from-club?team_id=${teamID}`,
    type: 'delete',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/team.service.js